module.exports = __webpack_public_path__ + "img/video-intelligence.8f698adc.png";